import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/products/:slug',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue')
  },
  {
    path: '/portfolios',
    name: 'Portfolios',
    component: () => import('../views/Portfolios.vue')
  },
  {
    path: '/portfolios/:slug',
    name: 'PortfolioDetail',
    component: () => import('../views/PortfolioDetail.vue')
  },
  // {
  //   path: '/blogs',
  //   name: 'Blogs',
  //   component: () => import('../views/Blogs.vue')
  // },
  // {
  //   path: '/blogs/:slug',
  //   name: 'BlogsDetail',
  //   component: () => import('../views/BlogDetail.vue')
  // },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  { 
    path: '/404', 
    component: () => import('../views/404.vue') 
  },  
  { path: '*', redirect: '/404' },

  {
    path: '/theadmin/signin',
    name: 'AdminSignIn',
    component: () => import('../views/AdminSignIn.vue')
  },
  {
    path: '/theadmin/portfolios',
    name: 'AdminPortfolios',
    component: () => import('../views/AdminPortfolio.vue'),
    meta: {
      requiresAuth : true
    }
  },
  {
    path: '/theadmin/products',
    name: 'AdminProducts',
    component: () => import('../views/AdminProduct.vue'),
    meta: {
      requiresAuth : true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const currentUser = localStorage.getItem("z3dfklop")
  if(requiresAuth){
    if(currentUser == 'true'){
      next()
    }else{
      next('theadmin/signin')
    }
  }else{
    next()
  }
})

export default router
